/**
 * FileGetReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * FileGetReq
 */
export interface FileGetReq {
  /** 文件ID，支持逗号分隔批量查询 */
  id: string
}

/**
 * FileGetReq Schema
 */
export const FileGetReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '文件ID，支持逗号分隔批量查询',
      format: 'string',
      type: 'string',
      label: '文件ID',
    },
  },
  required: ['id'],
  type: 'object',
}
